<template>
  <div class="page-container">
    <AppHeader title="Theme Colors Settings" />

    <div class="container-fluid">
      <!-- Action Bar -->
       <!-- <div v-if="!showForm" class="action-bar">
        <button class="btn btn-primary action-btn" @click="handleNewColor">
          <i class="glyphicon glyphicon-plus"></i> New Color
        </button>
      </div>  -->

      <!-- Colors Table -->
      <div v-if="!showForm" class="table-container">
        <div class="table-responsive table-wrap">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Color Name</th>
                <th>Value</th>
                <th>Description</th>
                <th>Preview</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(color, index) in colors" :key="index">
                <td>{{ nameMapping[color.Name || color.name] || (color.Name || color.name) }}</td>
                <td>{{ color.Value || color.value }}</td>
                <td>{{ color.Description || color.description || '-' }}</td>
                <td class="preview-cell">
                  <div class="color-preview" :style="{ backgroundColor: color.Value || color.value }"></div>
                </td>
                <td>
                  <button class="btn btn btn-success me-2" @click="handleEditColor(color)">Edit</button>
                  <button class="btn btn btn-danger" @click="handleDeleteColor(color)">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Add/Edit Form -->
      <div v-if="showForm" class="form-card">
        <div class="card-header">
          <h3>{{ isEditing ? 'Edit Color' : 'Add New Color' }}</h3>
        </div>
        <div class="card-body">
          <div class="form-group mb-3">
            <label>Color Name</label>
            <div class="input-group">
               <input 
                type="text" 
                v-model="form.name" 
                class="form-control" 
                placeholder="e.g. primary, secondary, --custom-color" 
                list="predefined-names"
              >
              <datalist id="predefined-names">
                <option value="primary">Primary</option>
                <option value="secondary">Secondary</option>
                <option value="accent">Accent</option>
                <option value="bgStart">Background Start</option>
                <option value="bgEnd">Background End</option>
                <option value="tableHeader">Table Header</option>
                <option value="tableBorder">Table Border</option>
                <option value="tableRowEven">Table Row Even</option>
                <option value="tableRowHover">Table Row Hover</option>
                <option value="scrollbarThumb">Scrollbar Thumb</option>
                <option value="scrollbarTrack">Scrollbar Track</option>
                <option value="textMain">Text Main</option>
                <option value="textMuted">Text Muted</option>
                <option value="form">Form Background</option>
              </datalist>
            </div>
            <small class="text-muted">Select a standard name or enter a custom one.</small>
          </div>

          <div class="form-group mb-3">
            <label>Description</label>
            <input 
              type="text" 
              v-model="form.description" 
              class="form-control" 
              placeholder="e.g. Used for primary buttons and links"
            >
          </div>

          <div class="form-group mb-3">
            <label>Color Value</label>
            <div class="d-flex align-items-center gap-2">
              <input type="color" v-model="colorPickerValue" class="form-control form-control-color" @input="updateColorFromPicker" title="Choose your color">
              <input type="text" v-model="form.value" class="form-control" placeholder="#RRGGBB or rgba(r,g,b,a)">
            </div>
          </div>

          <div class="form-group mb-3">
             <label>Preview</label>
             <div class="color-preview-large" :style="{ backgroundColor: form.value }">
               <span>Text Contrast Check</span>
             </div>
          </div>

          <div class="actions-row mt-4">
            <button class="btn btn-danger me-2" @click="cancelForm">Cancel</button>
            <button class="btn btn-success" @click="saveColor">{{ isEditing ? 'Update' : 'Save' }}</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import commonServices from "@/shared/commonServices";
import axios from "axios";
import Swal from 'sweetalert2';

export default {
  name: "ThemeSettings",
  components: { AppHeader },
  mixins: [commonServices],
  data() {
    return {
      colors: [],
      showForm: false,
      isEditing: false,
      isCustomName: false,
      nameMapping: {
        'primary': 'Primary Color',
        'secondary': 'Secondary Color',
        'accent': 'Accent Color',
        'bgStart': 'Background Start',
        'bgEnd': 'Background End',
        'tableHeader': 'Table Header Background',
        'tableBorder': 'Table Border Color',
        'tableRowEven': 'Table Row Even Background',
        'tableRowHover': 'Table Row Hover Background',
        'scrollbarThumb': 'Scrollbar Thumb',
        'scrollbarTrack': 'Scrollbar Track',
        'textMain': 'Main Text Color',
        'textMuted': 'Muted Text Color',
        'form': 'Form Background Color'
      },
      form: {
        id: null,
        name: "",
        value: "#000000",
        description: ""
      },
      colorPickerValue: "#000000"
    };
  },
  mounted() {
    this.fetchColors();
  },
  methods: {
    async fetchColors() {
      try {
        let dataURL = this.apiURL + "Theme/getThemeColors";
        let response = await axios.get(dataURL);
        if (response.data && Array.isArray(response.data)) {
          this.colors = response.data;
        } else {
          this.colors = [];
        }
      } catch (error) {
        console.error("Error fetching colors:", error);
      }
    },
    handleNewColor() {
      this.isEditing = false;
      this.isCustomName = false;
      this.form = { id: null, name: "", value: "#ffffff", description: "" };
      this.colorPickerValue = "#ffffff";
      this.showForm = true;
    },
    handleEditColor(color) {
      this.isEditing = true;
      const name = color.Name || color.name;
      this.isCustomName = !this.nameMapping[name];

      this.form = { 
        id: color.Id || color.id, 
        name: name, 
        value: color.Value || color.value,
        description: color.Description || color.description || ""
      };
      // Try to set picker value if it's a valid hex
      if (this.form.value.match(/^#[0-9A-F]{6}$/i)) {
        this.colorPickerValue = this.form.value;
      }
      this.showForm = true;
    },
    updateColorFromPicker() {
      this.form.value = this.colorPickerValue;
    },
    cancelForm() {
      this.showForm = false;
    },
    async saveColor() {
      if (!this.form.name || !this.form.value) {
        Swal.fire('Error', 'Name and Value are required', 'error');
        return;
      }

      try {
        const payload = {
          Name: this.form.name,
          Value: this.form.value,
          Description: this.form.description,
          Id: this.form.id
        };
        
        // Assuming endpoints based on user description
        let endpoint = this.isEditing ? "Theme/updateThemeColor" : "Theme/saveThemeColor";
        let dataURL = this.apiURL + endpoint;
        
        let response = await axios.post(dataURL, payload);
        
        if (response.data.status === 'success' || response.status === 200) {
           Swal.fire('Success', 'Color saved successfully', 'success');
           this.showForm = false;
           this.fetchColors();
           this.fetchAndApplyThemeColors(); // Apply changes immediately
        } else {
           Swal.fire('Error', 'Failed to save color', 'error');
        }
      } catch (error) {
        console.error("Error saving color:", error);
        Swal.fire('Error', 'An error occurred', 'error');
      }
    },
    async handleDeleteColor(color) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let dataURL = this.apiURL + "Theme/deleteThemeColor";
            // Sending ID or Name depending on API requirement. Assuming ID or Name.
            // Using POST with payload
            await axios.post(dataURL, { Id: color.Id || color.id, Name: color.Name || color.name });
            
            Swal.fire('Deleted!', 'Color has been deleted.', 'success');
            this.fetchColors();
            this.fetchAndApplyThemeColors();
          } catch (error) {
             console.error("Error deleting color:", error);
             Swal.fire('Error', 'Failed to delete color', 'error');
          }
        }
      })
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: var(--theme-bg-end);
  color: var(--theme-text-main);
}

.content-wrapper {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.actions-row {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.table-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.table {
  color: white;
  margin-bottom: 0;
}

.table th, .table td {
  border-color: rgba(255, 255, 255, 0.1);
  vertical-align: middle;
}

.color-preview {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.2);
}

.color-preview-large {
  width: 100%;
  height: 100px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.form-card {
  background: var(--form-color);
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  max-width: 600px;
  margin: 0 auto;
}

.card-header {

  background: color-mix(
  in srgb,
  var(--form-color) 90%,
  white 10%
);

  padding: 15px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: white;
}

.card-body {
  padding: 20px;
}

.form-control {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

.form-control:focus {
  background: rgba(0, 0, 0, 0.3);
  border-color: var(--theme-primary);
  color: white;
  box-shadow: none;
}

.form-control-color {
  width: 60px;
  padding: 5px;
  height: 38px;
}

.text-muted {
  color: rgba(255, 255, 255, 0.5) !important;
}

.me-2 { margin-right: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }
.mt-4 { margin-top: 1.5rem; }
.gap-2 { gap: 0.5rem; }
.d-flex { display: flex; }
.align-items-center { align-items: center; }

.preview-cell { display: flex; align-items: center; justify-content: center; }
</style>
